import React from 'react';
import { RadioParam } from '../../types/RadioParam';
import { useHtmlValidId } from '../../../../hooks/useHtmlValidId';

type HTMLInputProps = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;
type Radio = { label: string; helpText?: string; param?: RadioParam<string> } & Omit<
  HTMLInputProps,
  'id' | 'className' | 'type'
>;

function normalizeParamsToHTMLAttributes(htmlInputProps: HTMLInputProps, param?: RadioParam<string>) {
  return {
    name: param?.name,
    value: param?.value,
    required: param?.required,
    defaultChecked: param?.checked,
    ...htmlInputProps,
  };
}

/**
 * Radio Button to be used with RadioGroup.
 */
export function Radio({ label, param, ...htmlInputProps }: Radio) {
  const id = useHtmlValidId();
  const radioId = `radio-${id}`;

  const htmlAttributes = normalizeParamsToHTMLAttributes(htmlInputProps, param);

  return (
    <p className={htmlAttributes.disabled ? 'form2-radio form2-radio--disabled' : 'form2-radio'}>
      <input className="form2-radio__input" id={radioId} type="radio" {...htmlAttributes} />
      <label className="form2-radio__label font-bold-15-25" htmlFor={radioId}>
        {label}
      </label>
    </p>
  );
}
